import Vue from 'vue'

const state = () => {
  return {
    list: [],
    selected: null
  }
}

const getters = {}

const mutations = {
  SET_CHANGELOGS(state, changelogs) {
    state.list = [...changelogs]
  },
  ADD_CHANGELOG(state, changelog) {
    state.list.push(changelog)
  },
  SET_SELECTED_CHANGELOG(state, changelog) {
    state.selected = changelog
  }
}

const actions = {
  async getChangelogs({ rootState, commit }) {
    try {
      //const slug = rootState.features.selected
      let { data } = await Vue.axios.get(`changelogs`)
      commit('SET_CHANGELOGS', data)
    } catch (error) {}
  },

  async getChangelog({ rootState, commit }, slug) {
    try {
      //const slug = rootState.features.selected
      let { data } = await Vue.axios.get(`changelog/${slug}`)
      commit('SET_SELECTED_CHANGELOG', data)
    } catch (error) {}
  },

  async postChangelog({ commit }, changelog) {
    try {
      let { data } = await Vue.axios.post(`changelogs`, changelog)
      commit('ADD_CHANGELOG', data)
    } catch (error) {}
  },

  async postChangelogReceived({ commit }, event) {
    const {  changelog  } = event
    commit('ADD_CHANGELOG', changelog)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
